import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Phone, Send } from "lucide-react";
import { waLink, telLink } from "@/lib/site";

export const CtaBanner = ({ title = "Ready to book your move?", subtitle = "Free quote in 15 minutes on WhatsApp. Fully insured, transparent pricing." }) => (
  <section data-testid="cta-banner" className="py-16 md:py-24">
    <div className="max-w-6xl mx-auto px-6 lg:px-8">
      <div className="rounded-[2rem] bg-[#0A192F] text-white p-8 sm:p-12 md:p-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.06]" aria-hidden style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
          backgroundSize: "28px 28px",
        }} />
        <div className="relative grid md:grid-cols-5 gap-8 items-center">
          <div className="md:col-span-3">
            <h2 className="font-display font-semibold text-3xl sm:text-4xl tracking-tight">{title}</h2>
            <p className="mt-3 text-slate-300 text-lg leading-relaxed">{subtitle}</p>
          </div>
          <div className="md:col-span-2 flex flex-col sm:flex-row md:flex-col gap-3">
            <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="cta-banner-wa"
               className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-6 py-3.5 font-semibold hover:brightness-95 transition">
              <MessageCircle className="h-4 w-4" /> WhatsApp us
            </a>
            <a href={telLink} data-testid="cta-banner-call"
               className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#0A192F] px-6 py-3.5 font-semibold hover:bg-slate-100 transition">
              <Phone className="h-4 w-4" /> Call now
            </a>
            <Link to="/#contact" data-testid="cta-banner-quote"
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 text-white px-6 py-3.5 font-semibold hover:bg-white/10 transition">
              <Send className="h-4 w-4" /> Get free quote
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);
